import React from "react";

import styles from "./WriteToManager.module.scss";

import PreviousPage from "../../partials/PreviousPage/PreviousPage";
import DataCollector from "../../UI/DataCollector/DataCollector";
import SubmitContactForm from "../../partials/SubmitContactForm/SubmitContactForm";

const WriteToManager: React.FC = () => {
  const [formData, setFormData] = React.useState({
    name: "",
    city: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (field: string) => (value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <section className={styles.writeToManager}>
      <div className="container">
        {<PreviousPage currentPage="Написать руководителю" title="Написать руководителю" />}
        <p className={styles.text}>
          Здесь вы можете оставить свое обращение в компанию Тканополис. Благодарим вас за обратную связь, нам очень важно ваше мнение!
        </p>
        <form className={styles.form} onSubmit={(e) => e.preventDefault()}>
          <h3 className={styles.subtitle}>Контактная информация</h3>

          <div className={styles.top}>
            <div className={styles.item}>
              <DataCollector mode="regular" title="Ваше имя*" value={formData.name} onChange={handleChange("name")} />
            </div>
            <div className={styles.item}>
              <DataCollector mode="regular" title="Город*" value={formData.city} onChange={handleChange("city")} />
            </div>
            <div className={`${styles.item} ${styles.tel}`}>
              <DataCollector
                mode="tel"
                title="Телефон*"
                placeholder="+7 (999) 999-9999"
                value={formData.phone}
                onChange={handleChange("phone")}
              />
            </div>
            <div className={styles.item}>
              <DataCollector mode="email" title="Email*" value={formData.email} onChange={handleChange("email")} />
            </div>
          </div>
          <div className={styles.message}>
            <DataCollector mode="message" title="Сообщение*" value={formData.message} onChange={handleChange("message")} />
          </div>
          <SubmitContactForm />
        </form>
      </div>
    </section>
  );
};

export default WriteToManager;
